var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Healthy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Healthy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick-On-Green"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Item-Checkbox-(off)",
    fill: "#53B53D",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43541183,17.7541066 L5.43867964,13.8487416 C5.05731206,13.5160624 5.04205736,12.9519541 5.40817023,12.5903462 C5.7590284,12.2287383 6.35396182,12.214274 6.7353294,12.5614176 L9.66423238,14.5430287 C9.83203411,14.6876719 10.0913641,14.6587432 10.2286564,14.4851715 L16.3124034,7.21336933 C16.6174975,6.82283283 17.2124309,6.73604694 17.6243079,7.03979755 C18.0361849,7.32908385 18.1277131,7.89319214 17.8073643,8.28372864 L10.8235898,17.6383921 C10.6557881,17.8408925 10.4117128,17.9710714 10.1523829,17.9855357 C10.1218735,18 10.1066188,18 10.0761094,18 C9.83203411,18 9.60321357,17.9132141 9.43541183,17.7541066 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthy);
export default __webpack_public_path__ + "static/media/healthy.30f422d183f1618899a0ccdaafb19d84.svg";
export { ForwardRef as ReactComponent };